import type { ApiErrorDto } from '@reelplicate/api-client/model';
import { isAxiosError } from 'axios';

/** Best human-readable message for anything thrown by a request or a render. */
export function getErrorMessage(error: unknown): string {
  if (isAxiosError<ApiErrorDto>(error)) {
    const message = error.response?.data?.message;
    if (Array.isArray(message)) return message.join(', ');
    if (message) return message;
    if (!error.response) return 'Cannot reach the server. Check your connection.';
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong';
}
